import { useLocation } from 'react-router-dom'
import FormMovieData from '../../forms/FormMovieData'
import WrapperPageSimple from '../../WrapperPage/present/WrapperPageSimple'
import { ORIGIN_TMDB, ORIGIN_PM } from '../../../constants/metaMovieOrigins'

const EditMovie = ({
    itemId,
    movieExtensionsItems,
    movieExtensionsToReset,
    onUpdateExtension,
    onResetExtension,
    metaData,
    sourceData,
    movies,
    sourceDataProvider,
    performances,
    attributes,
    movieExist,
    sourceMoviesByItemId,
    cliMovieRelevantSourceMovies,
    closePagePath,
    onUpdateItem,
    onChangeField,
    onResetField,
    isTmdbLinked,
    hasPreviewMovie,
    onSetOrigin,
    onNavigate,
    pmMovie,
    tmdbMovie,
}) => {
    const location = useLocation()
    const cliMovie = movieExist ? movies[itemId] : {}
    const origin = (key) => metaData && metaData[key]
    const itemData = movieExist ? {
        ...cliMovie,
        logo: origin('logo') === ORIGIN_PM ? (pmMovie && pmMovie.logo) : cliMovie.logo,
        trailerURL: origin('trailerURL') === ORIGIN_PM
            ? (pmMovie && pmMovie.trailerURL)
            : cliMovie.trailerURL,
        title: origin('title') === ORIGIN_TMDB && tmdbMovie && tmdbMovie.title
            ? tmdbMovie.title
            : cliMovie.title,
        description: origin('description') === ORIGIN_TMDB && tmdbMovie && tmdbMovie.description
            ? tmdbMovie.description
            : origin('description') === ORIGIN_PM
                ? (pmMovie && pmMovie.description)
                : cliMovie.description,
        images: {
            ...(cliMovie.images || {}),
            poster: (pmMovie && pmMovie.images && pmMovie.images.poster) ? pmMovie.images.poster : (cliMovie.images && cliMovie.images.poster),
            ambient: (pmMovie && pmMovie.images && pmMovie.images.ambient) ? pmMovie.images.ambient : (cliMovie.images && cliMovie.images.ambient),
            backgrounds: (pmMovie && pmMovie.images && pmMovie.images.backgrounds && pmMovie.images.backgrounds.length > 0)
                ? pmMovie.images.backgrounds
                : (cliMovie.images && cliMovie.images.backgrounds) || [],
        }
    } : {}
    const pageName = movieExist && itemData.title ? itemData.title : 'Film nicht gefunden' 
    
    return (
        <WrapperPageSimple
            pageTitle={pageName} 
            closePagePath={closePagePath}
            id={itemId}
        >
            <div className="program-page site-content">
                {movieExist  ? (
                    <>
                    <div className="edit-movie-header-actions">
                        <button
                            className={'tmdb-edit-btn' + (isTmdbLinked ? ' tmdb-edit-btn--linked' : '')}
                            onClick={() => onNavigate(`/tmdb/${itemId}?from=${encodeURIComponent(location.pathname)}`)}
                        >
                            <span className="tmdb-edit-btn-text text-light-uppercase">{isTmdbLinked ? 'TMDB bearbeiten' : 'TMDB verknüpfen'}</span>
                        </button>
                        <button
                            className="tmdb-edit-btn tmdb-edit-btn--plain"
                            onClick={() => onNavigate(`/meta-mapping?pk=${itemId}`)}
                        >
                            <span className="tmdb-edit-btn-text text-light-uppercase">Filme verknüpfen/trennen</span>
                        </button>
                    </div>
                    <FormMovieData
                        movieData={itemData}
                        metaData={metaData}
                        sourceData={sourceData}
                        sourceDataProvider={sourceDataProvider}
                        attributes={attributes}
                        performances={performances}
                        cliMovieRelevantSourceMovies={cliMovieRelevantSourceMovies}
                        sourceMoviesByItemId={sourceMoviesByItemId}
                        movieExtensionsItems={movieExtensionsItems}
                        movieExtensionsToReset={movieExtensionsToReset}
                        onUpdateExtension={onUpdateExtension}
                        onResetExtension={onResetExtension}
                        closePagePath={closePagePath}
                        onUpdateItem={onUpdateItem}
                        onChangeField={onChangeField}
                        onResetField={onResetField}
                        isTmdbLinked={isTmdbLinked}
                        hasPreviewMovie={hasPreviewMovie}
                        onSetOrigin={onSetOrigin}
                        pmMovie={pmMovie}
                        tmdbMovie={tmdbMovie}
                    />
                    </>
                ):(
                    <div>Keine Daten</div>
                )}
            </div>
        </WrapperPageSimple>
    )
}

export default EditMovie